import { css } from '@emotion/react';

import { theme } from 'src/styles/theme';

export const styles = {
    text: css({
        '& a': {
            color: theme.palette.primary.main,
            textDecoration: 'underline',
        },
    }),

    subtitleSecondary: {
        margin: '20px 0 20px -42px',
        [theme.breakpoints.down('lg')]: {
            marginLeft: '-50px',
        },
    },
};
